import Glide from "@glidejs/glide";
import { Breakpoints } from "@glidejs/glide/dist/glide.modular.esm";
import { gsap, TimelineMax } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

gsap.registerPlugin(ScrollTrigger);

export default {
	init() {

		const scene = document.querySelector(".scene");
		const details = document.querySelectorAll(".offer__inner");
		const offerList = document.querySelectorAll(".offer-list");

		let offset = 0;
		let position = "absolute";
		let sceneStyle = getComputedStyle(scene,":before");

		document.documentElement.style.setProperty("--offset", offset);
		document.documentElement.style.setProperty("--position", position);

		if (window.innerWidth <= 480) {
			offset = window.innerHeight / 2.5;
			document.documentElement.style.setProperty("--offset", `${offset}px`);
		}

		/* Introdukcja */

		const tl = new TimelineMax();

		const heroTitle = document.querySelector(".title--hero");
		const heroOverlay = document.querySelector(".intro__overlay");

		tl.fromTo(heroTitle.children[0], .5, { x: "20px", opacity: 0 }, { x: 0, opacity: 1 }, "+=.5");
		tl.fromTo(heroTitle.children[1], .5, { x: "-50px", opacity: 0 }, { x: 0, opacity: 1 }, "-=.5");
		tl.fromTo(heroTitle.children[2], .5, { x: "-20px", opacity: 0 }, { x: 0, opacity: 1 }, "-=.7");
		tl.to(heroOverlay, 2, { opacity: 0 }, "-=.5");

		/* Animacja linków w nawigacji */

		const setActiveClass = (index, reset) => {
			const navLinks = document.querySelectorAll(".menu--top .menu__link");
			navLinks.forEach(item => item.classList.remove("menu__link--active"));
			navLinks[index].classList.add("menu__link--active");

			if (reset) {
				navLinks.forEach(item => item.classList.remove("menu__link--active"));
			}
		}

		gsap.utils.toArray("[data-scroll]").forEach((el, i) => {
			gsap.to(el, { scrollTrigger: {
					trigger: el,
					start: "-10% top",
					scrub: true,
					// markers: true,
					onEnter: () => {
						setActiveClass(i);
					},
					onEnterBack: () => {
						setActiveClass(i);
					},
					onLeaveBack: (self) => {

						if (i === 0 && self.direction === -1) {
							setActiveClass(i, true);
						}
					}
				}
			});
		});

		/* Nagłówki */

		const intro = document.querySelector(".intro");
		let scrollY = window.scrollY;

		gsap.timeline({
			defaults: {
				duration: 1
			},
			scrollTrigger: {
				trigger: intro,
				start: "top top",
				end: "bottom top",
				scrub: true,
				// markers: true,
				onLeave: (self) => {

					position = "fixed";
					document.documentElement.style.setProperty("--position", `${position}`);
					scrollY = 0;

					if (window.innerWidth <= 480) {
						offset = window.innerHeight / 2.5;
						document.documentElement.style.setProperty("--offset", `-${window.innerHeight - offset}px`);
					} else {
						offset = window.innerHeight;
						document.documentElement.style.setProperty("--offset", `-${offset}px`);
					}
				},
				onUpdate: (self) => {

					if (self.direction === -1) {

						offset = window.innerHeight / 2.5;
						position = "absolute";
						document.documentElement.style.setProperty("--position", `${position}`);
						if (window.innerWidth <= 480) {
							document.documentElement.style.setProperty("--offset", `${offset}px`);
						} else {
							document.documentElement.style.setProperty("--offset", `-${scrollY}px`);
						}
					}
				}
			}
		});

		const titles = document.querySelectorAll(".copy-scroll__inner");

		titles.forEach((target, index) => {
			gsap.timeline({
				defaults: {
					duration: 1
				},
				scrollTrigger: {
					trigger: target,
					start: "top top",
					end: "bottom top",
					pin: true,
					pinSpacing: false,
					scrub: true,
					// markers: true,
					onEnter: (self) => {

						if (index === 0) {
							gsap.set(".copy-scroll .ornaments", { position: "fixed" });
						}

						if (index === 3) {
							gsap.set(".copy-scroll .ornaments", { position: "absolute" });
						}
					},
					onLeaveBack: (self) => {

						if (index === 0) {
							gsap.set(".copy-scroll .ornaments", { position: "absolute" });
						}
					},
					onUpdate: (self) => {

						if (index === 3 && self.direction === 1) {
							document.documentElement.style.setProperty("--offset", `-${window.innerHeight++}px`);
						}

						if (index === 3 && self.direction === -1) {
							document.documentElement.style.setProperty("--offset", `-${window.innerHeight--}px`);
						}
					}
				}
			})
			.fromTo(target, { y: 50}, { y: -50 })
			.from(target, { opacity: 0, duration: .2}, 0)
			.to(target, { opacity: 0, duration: .2},  .8)
		});

		/* Oferta */

		gsap.timeline({
			defaults: {
				duration: 1
			},
			scrollTrigger: {
				trigger: ".offer-scroll__intro",
				start: "top top",
				end: "bottom 100%",
				scrub: true,
				// markers: true,
				onEnter: (self) => {
					gsap.set(".offer-scroll .ornaments", { position: "fixed" });
				},
			}
		});

		const listOffset = document.querySelector(".offer-list");
		let listOffsetCSS = window.getComputedStyle(listOffset);
		let value = listOffsetCSS.getPropertyValue("padding-top");
		const offers = document.querySelectorAll(".offer-scroll__inner");
		const offersTitle = document.querySelector(".offer__title--typed");

		offers.forEach((target, index) => {
			gsap.timeline({
				defaults: {
					duration: 1
				},
				scrollTrigger: {
					trigger: target,
					start: "top top",
					end: "bottom top",
					pin: true,
					pinSpacing: false,
					scrub: true,
					// markers: true,
					onEnter: (self) => {

						if (index === 0) {
							gsap.to(".offer-scroll__title", { opacity: 0 });
							gsap.to(".offer__dot", { y: `-${parseInt(value) / 2}` });
						}

						if (index === 3) {
							gsap.set(".offer-scroll .ornaments", { position: "absolute" });
						}

						gsap.to(target.querySelector("span"), { duration: .75, width: "100%" });
						gsap.fromTo(target.querySelectorAll("li"), { y: "-50px", opacity: 0 }, { y: 0, opacity: 1, stagger: .1, ease: "easeInOut" });
					},
					onLeaveBack: (self) => {

						if (index === 0) {
							gsap.to(".offer-scroll__title", { opacity: 1 });
							gsap.to(".offer__dot",{ y: 0 });
						}
					}
				}
			})
			.from(target, { opacity: 0, duration: .2 }, 0)
			.to(target, { opacity: 0, duration: .2 },  .8)
		});

		/* Liczniki */

		const setRandomClasses = () => {
			const digitsWrapper = document.querySelectorAll(".digit__wrapper");

			for (let i = 0; i < digitsWrapper.length; i++) {

				if (digitsWrapper.length % Math.floor(Math.random() * 5)) {
					digitsWrapper[i].classList.add("digit__wrapper--5");
				}

				if (digitsWrapper.length % Math.floor(Math.random() * 7)) {
					digitsWrapper[i].classList.add("digit__wrapper--7");
				}

				if (digitsWrapper.length % Math.floor(Math.random() * 9)) {
					digitsWrapper[i].classList.add("digit__wrapper--9");
				}
			}
		}

		setRandomClasses();

		const startCounting = (element, random) => {
			const counter = document.querySelector(`.${element}`);
			const digitsWrapper = document.querySelectorAll(`.${element} .digit__wrapper`);
			const dataValue = counter.parentElement.dataset.count;
			let tweenDigits = [];

			for (let i = 0; i < dataValue.length; i++) {
				tweenDigits.push(parseInt(dataValue[i]));

				if (random) {
					tweenDigits = [];

					for (let i = 0; i < digitsWrapper.length; i++) {
						tweenDigits.push(parseInt(digitsWrapper[i].children[Math.floor(Math.random() * 9) + 1].textContent));
					}
				}
			};

			digitsWrapper.forEach((digit, index) => {
				gsap.to(digit, { y: `-${(digit.offsetHeight / 10) * tweenDigits[index]}px` });
			});
		};

		/* Maska */

		const maskHeading = (element, reset) => {
			const heading = document.querySelector(`.${element} span`);

			if (reset) {
				gsap.set(heading, { clearProps: "all" });
			} else {
				gsap.to(heading,{ duration: 1, width: "100%" });
			}
		};

		const counters = document.querySelectorAll(".counters");

		counters.forEach((target, index) => {
			gsap.timeline({
				defaults: {
					duration: 1
				},
				scrollTrigger: {
					trigger: target,
					start: "top top",
					end: "center top",
					pin: true,
					pinSpacing: false,
					scrub: true,
					// markers: true,
					onEnter: (self) => {

						if (index === 0) {
							startCounting("investments__title--investments");
							maskHeading("investments__desc--investments");
						}

						if (index === 1) {
							startCounting("investments__title--websites");
							maskHeading("investments__desc--websites");
						}

						if (index === 2) {
							startCounting("investments__title--campaigns");
							maskHeading("investments__desc--campaigns");
						}
					}
				}
			})
			.from(target, { opacity: 0, duration: .3}, 0)
			.to(target, { opacity: 0, duration: .3},  .5)
		});

		/* Slidery */

		const supportSlider = new Glide("#supportSlider", {
			type: "carousel",
			startAt: 1,
			perView: 1,
			gap: 50,
			peek: {
				before: 100,
				after: 100
			}
		});

		if (window.innerWidth <= 770) {
			supportSlider.mount();
		}

		/* Formularz kontaktowy */

		const contactForm = document.querySelector(".form");
		const formElements = contactForm.querySelectorAll(".form__element--input");

		formElements.forEach((element) => {

			const formElement = element.lastElementChild;

			formElement.addEventListener("focus", (e) => {

				e.currentTarget.parentElement.classList.add("form__element--active");

				if (e.currentTarget.value === "") {
					e.currentTarget.previousElementSibling.classList.add("form__label--active");
				}
			});

			formElement.addEventListener("blur", (e) => {

				e.currentTarget.parentElement.classList.remove("form__element--active");

				if (e.currentTarget.value === "") {
					e.currentTarget.previousElementSibling.classList.remove("form__label--active");
				} else {
					e.currentTarget.parentElement.classList.add("form__element--active");
				}
			});
		});

		const allowNumbersOnly = (e) => {
			const code = (e.which) ? e.which : e.keyCode;
			if (code > 31 && (code < 48 || code > 57)) {
				e.preventDefault();
			}
		}

		contactForm.querySelector("input[type='tel']").addEventListener("keypress", allowNumbersOnly);

		const resetValues = () => {
			contactForm.querySelector("input[type='text']").value = null;
			contactForm.querySelector("input[type='email']").value = null;
			contactForm.querySelector("input[type='tel']").value = null;
			contactForm.querySelector("input[type='checkbox']").checked = false;
			contactForm.querySelectorAll(".form__label--placeholder").forEach((placeholder) => {
				placeholder.classList.remove("form__label--active");
			});
		};

		const scriptURL = "https://script.google.com/macros/s/AKfycbxlM8sfLGDeLxA90k37RO51hWF09WK2neWCkLx_/exec";
		const form = document.forms["google-sheet"];
		const formTYP = document.querySelector(".form__typ");

		form.addEventListener("submit", (e) => {
			e.preventDefault();

			const object = {
				"fullName": form.querySelector("input[name='fullName']").value,
				"email": form.querySelector("input[name='email']").value,
				"phone": form.querySelector("input[name='phone']").value
			};

			const formData = new FormData();

			const getFormData = (object) => {
				Object.keys(object).forEach(key => formData.append(key, object[key]));
				return formData;
			}

			getFormData(object);

			fetch(scriptURL, { method: "POST", body: formData })
			.then((response) => {
				if (response.status == 200) {
					formTYP.classList.add("form__typ--active");

					setTimeout(() => {
						formTYP.classList.remove("form__typ--active");
						resetValues();
					}, 3000);
				}
				else {
					throw `error with status ${response.status}`;
				}
			})

			const endpoint = `${window.location.origin}/wp-json/email/v1/send-email`;
			const body = JSON.stringify(object);

			fetch(endpoint, {
				method: "post",
				body: body,
				mode: "cors",
				headers: {
					"Accept": "application/json",
					"Content-Type": "application/json",
				},
			})
			.then((response) => {
				if (response.status == 200) {
					setTimeout(() => {
						resetValues();
					}, 1000);
				}
				else {
					throw `error with status ${response.status}`;
					showNotice("Napotkano problem. Spróbuj później!", response.status);
				}
			})
		});

		/* Okienko ze zgodami */

		const overlay = document.querySelector(".overlay");
		const regulationBtn = document.querySelector(".form__regulations");
		const closeRegulations = document.querySelector(".popup__btn-agreement--close");
		const agreement = document.querySelector(".popup--agreement");

		regulationBtn.addEventListener("click", (e) => {
			e.preventDefault();
			disableBodyScroll(agreement);
			agreement.classList.add("popup--visible");
		});

		closeRegulations.addEventListener("click", (e) => {
			e.preventDefault();
			enableBodyScroll(agreement);
			agreement.classList.remove("popup--visible");
		});

	},
	finalize() {

	},
};